module.exports = __webpack_public_path__ + "img/logo.2c9d0b82.png";